import { render, staticRenderFns } from "./FormsUpdateReminderSettings.vue?vue&type=template&id=4fe5b350&scoped=true"
import script from "./FormsUpdateReminderSettings.vue?vue&type=script&lang=js"
export * from "./FormsUpdateReminderSettings.vue?vue&type=script&lang=js"
import style0 from "./FormsUpdateReminderSettings.vue?vue&type=style&index=0&id=4fe5b350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe5b350",
  null
  
)

export default component.exports